/** @file EditorStoreContext: the React context that hands every panel the one EditorStore. */
import { createContext } from 'react';
import type { EditorStore } from './editorTypes';

/** Provided once by the shell (or a dev harness); `useEditor` reads it. */
export const EditorStoreContext = createContext<EditorStore | null>(null);
